'use client';

import classnames from 'classnames/bind';
import { SpNavigationIsland } from '@portals/ui-kit-dpa';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { TMaterialsTreeItem } from '@/api/get-materials-tree/_types';
import { TMultiPageRouteParams } from '@/_constants/routes';
import { SERVER_CATEGORY_TREE_DISPLAY_ID } from './constants';
import { ScrollSaver } from './_components/scroll-saver';
import { ClientGoToHomeButton } from './_components/client-go-to-home-button'; // Импорт обертки
import { ServerCategoryItem } from './_components/server-category-item'; // Новый путь (будет создан)
import styles from './index.module.scss';

const BLOCK_NAME = 'Category-tree-display'; // Можно переименовать
const cn = classnames.bind(styles);

type TProps = {
  materialsTree: Array<TMaterialsTreeItem>;
  parentDict: Record<string, string>;
};

export const ServerCategoryTreeDisplay = ({
  materialsTree,
  parentDict,
}: TProps) => {
  const { materialId } = useParams<TMultiPageRouteParams>();

  const translations = useTranslations('help-center');
  const buttonText = translations('treeTitle');

  return (
    <ScrollSaver>
      <div className={cn(BLOCK_NAME)} id={SERVER_CATEGORY_TREE_DISPLAY_ID}>
        {/* Используем клиентскую обертку для кнопки "На главную" */}
        <ClientGoToHomeButton buttonText={buttonText} />
        <SpNavigationIsland activeId={materialId}>
          {materialsTree.map((item) => (
            <ServerCategoryItem
              parentDict={parentDict}
              key={item.id}
              category={item}
              childList={item.childCategories}
            />
          ))}
        </SpNavigationIsland>
      </div>
    </ScrollSaver>
  );
};
